import { Fragment, useEffect } from 'react';
import { cn } from './cn';
import { connectionStore, dismissConnection } from './connectionStore';
import { useStore } from './store';
import { useReducedMotion } from './useReducedMotion';

const VISIBLE_MS = 4000;

export function ConnectionToastHost() {
  const toast = useStore(connectionStore);
  const reduced = useReducedMotion();

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(dismissConnection, VISIBLE_MS);
    return () => clearTimeout(t);
  }, [toast]);

  const spoken = toast
    ? `${toast.headline}. Also in ${toast.steps
        .slice(1)
        .map((s) => (s.detail ? `${s.name} ${s.detail}` : s.name))
        .join(', ')}.`
    : '';

  return (
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed inset-x-4 bottom-[calc(88px+env(safe-area-inset-bottom))] z-40 mx-auto max-w-lg lg:bottom-6 lg:left-[calc(15rem+16px)]"
    >
      {toast ? (
        <div
          key={toast.id}
          data-testid="connection-toast"
          className="pointer-events-auto rounded-[14px] border border-border bg-surface-2 px-3 py-2.5 text-sm"
        >
          <p className="sr-only">{spoken}</p>
          <p aria-hidden className="text-fg">
            {toast.headline}
          </p>
          <div aria-hidden className="mt-1 flex items-center gap-1.5 text-xs text-muted">
            {toast.steps.map((s, i) => (
              <Fragment key={`${s.moduleId}-${i}`}>
                {i > 0 ? (
                  <span
                    data-thread
                    className={cn(
                      'h-0 min-w-4 flex-1 border-t-2 border-dashed border-accent',
                      !reduced && 'thread-draw',
                    )}
                  />
                ) : null}
                <span className="whitespace-nowrap">
                  {s.name}
                  {s.detail ? (
                    <span className="ml-1 font-mono tabular-nums text-fg">{s.detail}</span>
                  ) : null}
                </span>
              </Fragment>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
